import { Box } from '@zillow/constellation-10';

import AddAmenitiesFormField from '../AddAmenities/AddAmenitiesFormField';
import AmenitiesPropertyFormField from '../AmenitiesPropertyFormField';

import type { AmenityFieldDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  isRelistingFieldset?: boolean;
  additionalAmenitiesTopSpacing?: boolean;
  aiAmenityFields?: Array<AmenityFieldDto>;
};

const AmenitiesWithAdditionalAmenitiesFields = ({
  isRelistingFieldset,
  additionalAmenitiesTopSpacing = false,
  aiAmenityFields,
}: Props) => {
  return (
    <div data-testid="AmenitiesWithAdditionalAmenitiesFields">
      <AmenitiesPropertyFormField isRelistingFieldset={isRelistingFieldset} aiAmenityFields={aiAmenityFields} />
      <Box css={additionalAmenitiesTopSpacing ? { marginTop: '400' } : undefined}>
        <AddAmenitiesFormField isRelistingFieldset={isRelistingFieldset} />
      </Box>
    </div>
  );
};

export default AmenitiesWithAdditionalAmenitiesFields;
